import styled from 'styled-components';

export const FreightText = styled.span`
  font-size: 10px;
  color: #fa8c16;
`;
